<template>
    <div class="flex justify-center overflow-hidden h-7 leading-7">
        <span v-for="(digit, index) in digits" :key="index" class="inline-block">
            <span class="flex flex-col transition-transform duration-700 ease-in-out"
                :style="{ transform: `translateY(-${digit * 10}%)` }">
                <span v-for="i in 10" :key="i" class="h-[3.5rem] md:h-[5rem] lg:h-[6rem]">{{ i - 1 }}</span>
            </span>
        </span>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  number: {
    type: [Number, String],
    required: true,
    default: 0
  }
})

// A computed property that splits the number into an array of individual digits.
// This is what the template will use to render the rolling columns.
const digits = computed(() => {
  return String(props.number).split('').map(Number)
})

</script>

<style scoped>
/* Scoped styles for the component */

/* We need to set the height for the number containers to make the overflow work */
.h-\[3\.5rem\] {
    height: 3.5rem;
}

.md\:h-\[5rem\] {
    height: 5rem;
}

.lg\:h-\[6rem\] {
    height: 6rem;
}

.leading-\[3\.5rem\] {
    line-height: 3.5rem;
}

.md\:leading-\[5rem\] {
    line-height: 5rem;
}

.lg\:leading-\[6rem\] {
    line-height: 6rem;
}
</style>
